import {
  SAVED_DOCUMENT_ITEM_TYPE,
  type SavedDocumentItemType,
  type SavedDocumentTextRating,
  type SavedDocumentThread,
} from 'src/data/savedDocument';

import type { ResolvedAnchor } from './anchors';

export interface TrackedItem {
  type: SavedDocumentItemType;
  id: string;
  anchor: SavedDocumentThread['anchor'];
}

// The ratings on one exact piece of text, shown together in one card.
export interface RatingGroup {
  key: string;
  quote: string;
  ratings: SavedDocumentTextRating[];
  resolved: ResolvedAnchor;
}

export const getRangeKey = ({ start, end }: Pick<ResolvedAnchor, 'start' | 'end'>) =>
  `${start}-${end}`;

// A highlight's target names what a click on it opens: a thread or a group of ratings.
export const getThreadTarget = (id: string) => `thread:${id}`;
export const getRatingsTarget = (key: string) => `ratings:${key}`;

export const getTrackedItems = (
  threads: SavedDocumentThread[],
  textRatings: SavedDocumentTextRating[]
): TrackedItem[] => [
  ...threads.map(({ id, anchor }) => ({ type: SAVED_DOCUMENT_ITEM_TYPE.thread, id, anchor })),
  ...textRatings.map(({ id, anchor }) => ({
    type: SAVED_DOCUMENT_ITEM_TYPE.textRating,
    id,
    anchor,
  })),
];
